import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { COLOR } from '@src/styles/color';

const StyledInstructions = styled(Box)`
  display: flex;
  max-width: 960px;
  flex-direction: column;
  align-items: center;
  align-self: center;
  width: 100%;
  gap: 24px;
  padding: 40px;
  box-sizing: border-box;
  .cycle-blur-image {
    width: 248px;
    height: 248px;
  }
`;

const ContentWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 640px;
  gap: 24px;
  .input-label {
    margin-bottom: 4px;
    color: ${COLOR.darkGray};
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: -0.4px;
  }
  .input-error {
    margin-top: 2px;
  }
`;
const StyledInstructionsList = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;
export { StyledInstructions, ContentWrapper, StyledInstructionsList };
